module.exports = __webpack_public_path__ + "static/img/fif-logo.4890a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fif-logo.png
// module id = 5
// module chunks = 0